module.exports = __webpack_public_path__ + "img/dp-portfolio-05.494f1ea0.jpg";